var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdditionalResources = function SvgAdditionalResources(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M11.75 0.75H8.75V2.25H11.75C12.9875 2.25 14 3.2625 14 4.5C14 5.7375 12.9875 6.75 11.75 6.75H8.75V8.25H11.75C13.82 8.25 15.5 6.57 15.5 4.5C15.5 2.43 13.82 0.75 11.75 0.75ZM7.25 6.75H4.25C3.0125 6.75 2 5.7375 2 4.5C2 3.2625 3.0125 2.25 4.25 2.25H7.25V0.75H4.25C2.18 0.75 0.5 2.43 0.5 4.5C0.5 6.57 2.18 8.25 4.25 8.25H7.25V6.75ZM5 3.75H11V5.25H5V3.75Z",
    fill: "#3EB650"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdditionalResources);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "additional-resources.7dff47d84a399761667700fc3b094100.svg";